import { useMutation } from "@apollo/client";
import { ICardDeleteResponse } from "./card-delete.interface";
import { CARD_DELETE } from "./card-delete.mutation";

export const useCardDelete = () => {
  const [disableCard, { data, loading, error }] = useMutation<{ disableCard: ICardDeleteResponse }>(CARD_DELETE);

  const cardDelete = (cardId: string) => {
    disableCard({
      variables: { cardId },
    });
  };

  return {
    cardDelete,
    cardDeleted: data?.disableCard,
    loading,
    error,
  };
};
